import '@angular/localize/init';
import 'zone.js';

// This is required for buffer.js to work properly
(window as any).global = window;
